import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Miami needed",
      "Ideal for cruise passengers from Port Canaveral",
      "Perfect for surfers heading to Costa Rica and Central America",
      "Great for Cape Canaveral Space Force personnel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Brevard County post offices",
      "Good for planned international trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Brevard County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Miami — over 3 hours from Cocoa Beach",
      "NPIC appointment required before driving to Miami",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function CocoaBeachProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Cocoa Beach"
      introText="Most travelers only know the post office route. Here's the full picture — and how all four service tiers compare for Cocoa Beach residents."
      options={options}
      emergencyDescription="Cocoa Beach does not have its own regional passport agency. The closest is the Miami Passport Agency — over a 3-hour drive each way from Cocoa Beach, located at 1501 Biscayne Blvd Suite 210, Miami, FL 33132. You must secure an NPIC appointment in advance — no walk-ins permitted. Be prepared: the I-95 drive through South Florida, parking at the Biscayne Blvd federal building, wait time, and possibly being told to return the next day to pick up your passport can turn a one-day trip into two — and that's each way."
      disclaimerText="*Processing speed depends on eligibility and documentation. Cocoa Beach does not have a regional passport agency — the closest is Miami, roughly 3 hours away. Not all applicants qualify for Regional Agency Processing."
    />
  );
}